import * as t from 'io-ts';

import {AccountDetailsState, RAccountDetailsStateDirty} from './contactsManagerAccountDetailsState';
import {
  ContactsManagerCreateAccountFormState,
  RContactsManagerCreateAccountFormState,
} from './contactsManagerCreateAccountFormState';
import {
  ContactsManagerCreateContactFormState,
  RContactsManagerCreateContactFormState,
} from './contactsManagerCreateContactFormState';
import {
  ContactsManagerMergeContactsState,
  RContactsManagerMergeContactsState,
} from './contactsManagerMergeContactsState';
import {ContactsManagerSidePanelTypesEnum} from './contactsManagerSidePanelStateBase';

/*
 * Types.
 */

const RContactsManagerSidePanelStateDirty = t.taggedUnion('type', [
  RContactsManagerCreateContactFormState,
  RContactsManagerCreateAccountFormState,
  RAccountDetailsStateDirty,
  RContactsManagerMergeContactsState,
]);

export type ContactsManagerSidePanelState =
  | ContactsManagerCreateContactFormState
  | ContactsManagerCreateAccountFormState
  | AccountDetailsState
  | ContactsManagerMergeContactsState;

export const RContactsManagerSidePanelState = t.clean<ContactsManagerSidePanelState>(
  RContactsManagerSidePanelStateDirty as any,
);

/*
 * Type guards.
 */

export function sidePanelIsCreateContactForm(
  sidePanel: ContactsManagerSidePanelState | undefined,
): sidePanel is ContactsManagerCreateContactFormState {
  return sidePanel?.type === ContactsManagerSidePanelTypesEnum.CREATE_CONTACT;
}

export function sidePanelIsCreateAccountForm(
  sidePanel: ContactsManagerSidePanelState | undefined,
): sidePanel is ContactsManagerCreateAccountFormState {
  return sidePanel?.type === ContactsManagerSidePanelTypesEnum.CREATE_ACCOUNT;
}

export function sidePanelIsAccountDetails(
  sidePanel: ContactsManagerSidePanelState | undefined,
): sidePanel is AccountDetailsState {
  return sidePanel?.type === ContactsManagerSidePanelTypesEnum.ACCOUNT_DETAILS;
}

export function sidePanelIsMergeContactsForm(
  sidePanel: ContactsManagerSidePanelState | undefined,
): sidePanel is ContactsManagerMergeContactsState {
  return sidePanel?.type === ContactsManagerSidePanelTypesEnum.MERGE_CONTACTS;
}
